import React from 'react'
import EventServiceSection from '../../EventsComponents/EventServiceSection'
import ExperienceFormTab from './ExperienceFormTab'

const PhysicalFormTab: React.FC = (props) => {
  return (
    <ExperienceFormTab
      {...props}
      experience="physicals"
      experienceService="physicalService"
    >
      <EventServiceSection source="physicalService" />
    </ExperienceFormTab>
  )
}

export default PhysicalFormTab
